<script>
  import {list} from '../../../modules/api-client';
  import Select from 'svelte-select';

  export let value;
  export let ref;

  let item = value ? {value: value._id, label: value.name, val: value} : undefined;

  async function loadOptions(filterText) {
    return (await list(ref, {name: {$regex: filterText, $options: 'i'}}))
      .map(o => ({value: o._id, label: o.name, val: o}));
  }

  $: item, value = item?.val;
</script>

<Select containerClasses="form-control" bind:value={item} {loadOptions}/>
